<template>
    <div>
<div class="main-program-vue section-container" v-if="loading">
    <div v-if="sessionstyle != 'small'">
        <img class="hidden-md hidden-sm hidden-xs" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/Programm_Placeholder_Desktop_v1.svg" alt="">
        <img class="hidden-lg visible-md hidden-sm hidden-xs" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/Programm_Placeholder_Tablet_v1.svg" alt="">
        <img class="hidden-md hidden-lg" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/Programm_Placeholder_Mobile_v1.svg" alt="">
    </div>
    <div v-if="sessionstyle == 'small'">
        <img class="hidden-md hidden-sm hidden-xs" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/Programm_Placeholder_Desktop_v1.svg" alt="">
        <img class="hidden-lg hidden-sm hidden-xs" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/Programm_Placeholder_Tablet_v1.svg" alt="">
        <img class="hidden-md hidden-lg" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/Programm_Placeholder_Mobile_v1.svg" alt="">
    </div>
</div>
<div class="main-program-vue section-container pt-0" v-if="!loading">
    <!-- title start  -->
    <div v-if="title && title.length" class="gdlr-item gdlr-item-title-wrapper pos-center">
        <div class="gdlr-item-title-head">
            <h3 class="gdlr-item-title gdlr-skin-border gdlr-skin-title" :class="'gdlr-title-'+titlesize" :style="{'text-align':titleAlign}">{{title}}</h3>
        </div>
    </div>
    <!-- title Ends  -->
   
    <!-- program display starts  -->
    <div class="col-xs-12 wrapper-padding-mobile col-sm-12 session-item-wrapper" :class="{'col-md-12': sessionstyle == 'small','col-md-9': sessionstyle != 'small'}" :style="{'margin-bottom':marginBottom}">
        <div class="" :style="{ '--my-color': locationColor }">
            <!-- new layout starts -->
            <div class='new-layout-container rounded-l p-5 mb-5' :style="{'background-color':newLayoutBgColor}" v-if="result && result.vueSessions && result.vueSessions.Sessions && showNewLayout == 'enable'">
                <div v-if="sessionstyle === 'small'" class="session-display-small-new-layout">
                    <div v-for="(session, sessionIndex) in result.vueSessions.Sessions" :key="sessionIndex" class="eachSessionOfNewLayout">
                        <div v-if="session && session.type != 'Break'">
                            <div class="row">
                                <div v-if="session.sessionType && session.sessionType.type" class="session-type-icons">
                                    <div class="session-type-badge cathead-img new-layout-session-type">
                                        <h3 class="session-type-name" :style="{'color':session.sessionType.colourHexCode}">{{session.sessionType.type}}</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="">
                                    <div v-if="session && session.experts" class="column speaker-images-mobile-view">
                                        <div v-for="(expert, index) in session.experts" :key="index" class="gdlr-speaker-thumbnail mr-2">
                                            <div class="gdlr-speaker-thumbnail-inner programm-small-author">
                                                <a v-if="expert && expert.slug" :href="'/speaker/'+expert.slug">
                                                    <div v-if="expert.avatarSquareSmall && expert.avatarSquareSmall.xxx" class="sands-image-colored-overlay-hover">
                                                        <img class="img-black-white" :src="expert.avatarSquareSmall.xxx" :alt="expert.forename + ' ' + expert.surname + 'program display'" width="150" height="150">
                                                    </div>
                                                </a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-10">
                                    <h3 v-if="session.name" class="gdlr-session-item-title m--t--0 font-600">
                                        <a class="font-600" v-if="session.primaryTrack && session.primaryTrack.slug && session.slugNames && session.slugNames.length" :href="'/'+session.primaryTrack.slug+'/'+session.slugNames[0]" :aria-label="session.slugNames[0]">{{session.name}}</a>
                                        <span class="font-600" v-else>{{session.name}}</span>
                                    </h3>
                                    <div v-for="(expert, index) in session.experts" :key="index" class="twelve columns speakers-name-and-company">
                                        <a v-if="expert && expert.surname && expert.forename && expert.slug" :href="'/speaker/'+expert.slug">
                                            {{expert.forename}} {{expert.surname}}<span v-if="expert && expert.company">, &nbsp;<em> {{expert.company}}</em></span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- new layout ends -->

            <div v-if="showNewLayout == 'disable'" id="timetable-overview-custom" class="gdlr-session-item gdlr-full-session-item gdlr-item ml-0" :class="['{{days}}' ? 'timetable-day-'+days : '']">

                <!-- Tab new Filter -->
                <div class="hidden-xs visible-sm visible-md visible-lg" v-if="sessionstyle != 'small' && !programDisplayOnTrack">
                    <ul class="nav nav-tabs nav-program ml-0 font-14 font-md-14 font-sm-12 font-weight-bold">
                        <li class="border-radius-top-8 bg__grey">
                            <a @change="pgetWeekDayAsGroup()" @click="setActiveTab('types')" class="px-5 program-tabs" data-toggle="tab" :href="'#' + types">{{ $t('all-types') }}
                                <span>
                                    <img :src="isActiveTab('types') ? '/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/arrow_up.svg' : '/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/arrow_down.svg'" alt="Arrow" class="ml-2">
                                </span>
                            </a>
                        </li>
                        <li class="active border-radius-top-8 bg__grey">
                            <a @change="pgetWeekDayAsGroup()"  @click="setActiveTab('tracks')" class="px-5 program-tabs" data-toggle="tab" :href="'#' + tracks">{{ $t('all-tracks') }}
                                <span>
                                    <img :src="isActiveTab('tracks') ? '/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/arrow_up.svg' : '/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/arrow_down.svg'" alt="Arrow" class="ml-2">
                                </span>
                            </a>
                        </li>
                        <li class="border-radius-top-8 bg__grey" v-if="hasActiveFilters">
                            <a @click="resetFilters" class="px-5 program-tabs"> {{ theMaybeSetPLLCookieValue === 'de' ? 'Alle Filter zurücksetzen' : 'Reset all filters' }}
                                <span class="ml-3">
                                    <img src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/x_icon.svg" alt="X Icon" class="icon-small">
                                </span>
                            </a>
                        </li>
                    </ul>

                    <!-- Tab Content -->
                    <div class="tab-content font-12 font-weight-bold mb-4">
                        <div :id="types" class="tab-pane fade">
                            <div :id="splideTypesId" class="splide options-container border-radius-bottom-8" aria-label="Session type slider">
                            <div class="splide__track mx-4">
                                <div class="splide__list">
                                    <div class="splide__slide">
                                        <div @click="setFilter('ALL', 'type')" :class="['font-12', 'option-item', 'text-center', { 'selected': 'ALL' === typeToFilter }]">{{ $t('all-types') }}</div>
                                    </div>
                                    <div class="splide__slide" v-for="(aType, index) in typesFromQuery" :key="index">
                                        <div @click="setFilter(aType._id, 'type')" :class="['font-12', 'option-item', 'text-center', { 'selected': aType._id === typeToFilter }]">{{ aType.name }}</div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div :id="tracks" class="tab-pane fade in active">
                            <div :id="splideTracksId" class="splide options-container border-radius-bottom-8" aria-label="Track type slider">
                            <div class="splide__track  mx-4">
                                <div class="splide__list">
                                    <div class="splide__slide">
                                        <div @click="setFilter('ALL', 'track')" :class="['font-12', 'option-item', 'text-center', { 'selected': 'ALL' === trackToFilter }]">{{ $t('all-tracks') }}</div>
                                    </div>
                                    <div class="splide__slide" v-for="(aTrack, index) in tracksFromQuery" :key="index">
                                        <div @click="setFilter(aTrack._id, 'track')" :class="['font-12', 'option-item', 'text-center', { 'selected': aTrack._id === trackToFilter }]">{{ aTrack.name }}</div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Mobile Version -->
                <div class="mb-5 visible-xs hidden-sm hidden-md hidden-lg" v-if="sessionstyle != 'small' && !programDisplayOnTrack">
                    <ul class="nav nav-tabs ml-0 font-18 font-md-16 font-sm-10 font-weight-bold">
                        <li :class="[{ 'bg__active': activePopoverTabmobile === 'types' }, 'border-radius-top-8 bg__grey']">
                        <a @click="openPopover('types')" class="px-5 program-tabs">{{ $t('all-types') }}
                            <span>
                                <img :src="activePopoverTabmobile === 'types' ? '/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/arrow_up.svg' : '/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/arrow_down.svg'" alt="Arrow" class="ml-2">
                            </span>
                        </a>
                        </li>
                        <li :class="[{ 'bg__active': activePopoverTabmobile === 'tracks' }, 'border-radius-top-8 bg__grey']">
                        <a @click="openPopover('tracks')" class="px-5 program-tabs">{{ $t('all-tracks') }}
                            <span>
                                <img :src="activePopoverTabmobile === 'tracks' ? '/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/arrow_up.svg' : '/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/arrow_down.svg'" alt="Arrow" class="ml-2">                            
                            </span>
                        </a>
                        </li>
                        <li class="border-radius-top-8 bg__grey" v-if="hasActiveFilters">
                        <a @click="resetFilters" class="px-5 program-tabs"> {{ theMaybeSetPLLCookieValue === 'de' ? 'Alle Filter zurücksetzen' : 'Reset all filters' }}
                            <span class="ml-3">
                                <img src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/x_icon.svg" alt="X Icon" class="icon-small">
                            </span>
                        </a>
                        </li>
                    </ul>
                    <!-- Full-Screen Popover -->
                    <div v-if="activePopoverTab" class="popover-full-screen">
                        <div class="popover-content">
                        <div v-if="activePopoverTab === 'types'">
                            <div class="">
                                <div @click="setFilter('ALL', 'type')" :class="['popover-menu-program', 'program_item-popover-filter', 'font-12', { 'selected': 'ALL' === typeToFilter }]">{{ $t('all-types') }}</div>
                                <div v-for="(aType, index) in typesFromQuery" :key="index" @click="setFilter(aType._id, 'type')" :class="[{ 'selected': aType._id === typeToFilter }]" class="popover-menu-program program_item-popover-filter font-12">{{ aType.name }}</div>
                                <div class="text-center p-2">
                                <button @click="closePopover" class="close-popover">X</button>
                                </div>
                            </div>
                        </div>
                        <div v-if="activePopoverTab === 'tracks'">
                            <div class="">
                                <div @click="setFilter('ALL', 'track')" :class="['popover-menu-program', 'program_item-popover-filter', 'font-12', { 'selected': 'ALL' === trackToFilter }]">{{ $t('all-tracks') }}</div>
                             <div v-for="(aTrack, index) in tracksFromQuery" :key="index" @click="setFilter(aTrack._id, 'track')" :class="[{ 'selected': aTrack._id === trackToFilter }]" class="popover-menu-program program_item-popover-filter font-12">{{ aTrack.name }}</div>
                             <div class="text-center p-2">
                                <button @click="closePopover" class="close-popover">X</button>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                <!-- End Tab content -->

                <!-- filters old start -->
                <!-- <div class="shadow-s filters-outer-wrapper session-item-filter" v-if="!programDisplayOnTrack && showFilter && sessionstyle != 'small'">
                    <nav class="" role="navigation">
                        <form id="filtering-form-vue" v-on:submit="getfilteredData">
                            <div class="form-group">
                                <a name="search" id="search">
                                </a>
                            </div>
                            <span class="h4" style="font-weight: bold;">{{ $t('filter-by') }}</span>
                            <div class="filters-inner-wrapper m--t--5">
                                <div v-if="typesFromQuery && typesFromQuery.length" class="col-lg-4 col-md-4 col-sm-4 col-xs-12 filter-on-right-side-first p--l--0 filters-col">
                                    <div class="bootstrap-select-vue custom-select-vue">
                                        <select @change="pgetWeekDayAsGroup()" class="filterSelectVue program-filter-select rounded-corners-10" name="type" v-model="typeToFilter">
                                            <option id="123" class="defaultFilterOption" selected="selected" value="ALL">{{ $t('all-types') }}</option>
                                            <option v-for="(aType, index) in typesFromQuery" :value="aType._id" :key="index">{{aType.name}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div v-if="tracksFromQuery && tracksFromQuery.length" class=" col-lg-4 col-md-4 col-sm-4 col-xs-12 filter-on-right-side-second bootstrap-select p--l--0">
                                    <select @change="pgetWeekDayAsGroup()" class="filterSelectVue program-filter-select rounded-corners-10" name="track" v-model="trackToFilter">
                                        <option value="ALL" class="defaultFilterOption" selected="selected">{{ $t('all-tracks') }}</option>
                                        <option v-for="(aTrack, index) in tracksFromQuery" :value="aTrack._id" :key="index">{{aTrack.name}}</option>
                                    </select>
                                </div>
                            </div>
                        </form>
                    </nav>
                </div> -->
                <!-- filters old ends -->


                <div v-if="result && result.vueSessions && result.vueSessions.Sessions && showNewLayout == 'disable'">
                    <div v-for="(aDay, index) in programDisplay" :key="index" :id="'programJumpToDay'+index">

                        <!-- program sticky header start -->
                        <div v-if="showTimeAndDate && sessionstyle != 'small'">
                            <div class="gdlr-session-item-head gdlr-first d-flex justify-content-between onTop py-4 mb-2" :class="{'thisisthefirstdivider': index == 0,'onTop{{index}}' : true}">
                                <a v-for="(aDayTime, aDayTimeIndex) in getAllSessionTimes()" :key="aDayTimeIndex" class="Test table-head-link sigle-day-active aDayLink" :class="{'sigle-day-not-active': index > 0 && index != aDayTimeIndex, [getaDayTimeIndex(aDayTimeIndex)] : true}" :href="'#programJumpToDay'+aDayTimeIndex">
                                    <div class="gdlr-session-item-head-info  text-left " :class="{'sands-active': index == aDayTimeIndex,'sands-not-active' : index != aDayTimeIndex}">
                                        <div class="gdlr-session-head-weekday font-12 font-md-10 font-sm-10 font-xs-8 mb-2 text-color-1e">{{getFormattedDaily(aDayTime)}}</div>
                                        <div class="font-16 font-md-13 font-sm-10 font-xs-8 text-color-1e mb-2">{{ getFormattedDate(aDayTime) }}</div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <!-- program sticky header ends -->


                        <!-- Start day divider between cards -->
                        <div v-if="showTimeAndDate && sessionstyle != 'small' && index > 0" >
                            <div  v-for="(aDayTime, aDayTimeIndex) in getAllSessionTimes()" :key="aDayTimeIndex"  class="gdlr-session-item-content-wrapper break-parent-container border-radius-8 mb-5 day-selector-wrapper" :class="{'hidden': index != aDayTimeIndex}">
                                <div class="session-break-content">
                                    <div  class="font-weight-bold font-16">{{ getDay(aDayTime) }}</div>
                                    <div  class="gdlr-session-break-title font-weight-600 ml-0 font-20">{{ getFormattedDateDaily(aDayTime) }}</div>
                                </div>
                            </div>
                        </div>
                        <!-- End day divider between cards -->
                         
                        <div v-for="(session, sessionIndex) in aDay.sessions" :key="sessionIndex">
                            <!-- Break section -->
                            <!-- <div v-if="sessionstyle != 'small' && session.type == 'Break'" class="gdlr-session-item-content-wrapper break-parent-container  border-radius-8 mb-5">
                                <div class="session-break-content">
                                    <div class="session-break-info mb-0">
                                        <div  class="font-weight-bold font-16" v-if="showTimeAndDate && session.localizedStartDate">
                                            {{getTime(session.localizedStartDate)}} - {{getTime(session.localizedEndDate)}}
                                        </div>
                                        <div  class="gdlr-session-break-title font-weight-600 ml-0 font-20">{{session.name}}</div>
                                    </div>
                                </div>
                                <div class="clear"></div>
                            </div> -->

                            <!-- program card section -->
                            <div v-if="session.type != 'Break'" class="gdlr-session-item-content-wrapper program-card mb-5  ">
                                <!-- program header -->
                                <div class="program-header-color font-weight-600 px-1 px-md-5 border-radius-top-16 top-section">
                                    <div class="d-flex align-items-baseline p-3">
                                        <!-- date section -->
                                        <div v-if="showTimeAndDate && session.localizedStartDate && session.localizedEndDate && sessionstyle != 'small'"  class="session-date_info mr-3 mr-md-5">
                                            <div>
                                                <div class="session-info session-time text-white font-16 font-sm-12">
                                                    {{getTime(session.localizedStartDate)}} - {{getTime(session.localizedEndDate)}}
                                                </div>
                                            </div>
                                        </div>
                                        <!-- end date section -->
                                        <div class="session-type-icons ">
                                            <div v-if="showRoomBasedOfInstance && session.roomName && sessionstyle != 'small'" class="program-header-pils font-14 font-sm-10 mr-3">
                                                <span>{{session.roomName}}</span>
                                            </div>
                                            <div class="program-header-pils mr-3" :style="{'color':session.sessionType.colourHexCode}">
                                                <div class="session-name session-type-name session-type-name-color font-14 font-sm-10">{{session.sessionType.type}}</div>
                                            </div>
                                            <div v-if="showLanguageFlag && session.language && session.language == 'EN'" class="program-header-pils program-header-pils-language en font-14 font-sm-10">EN</div>
                                            <div v-if="showLanguageFlag && session.language && session.language == 'DE'" class="program-header-pils program-header-pils-language de font-14 font-sm-10">DE</div>
                                        </div>
                                    </div>
                                </div>
                                <!-- program headre end -->
                                <div class="bottom bg__grey pb-4 px-3 px-md-5">
                                    <a v-if="session.primaryTrack && session.primaryTrack.slug && session.slugNames && session.slugNames.length"  class="text-color-1e text-deco-none" :href="'/'+session.primaryTrack.slug+'/'+session.slugNames[0]" :aria-label="session.slugNames[0]+ ' ' + session.name">
                                        <h3 v-if="session.name" class="gdlr-session-item-title mb-2 font-22 mt-0 pt-3 text-deco-none font-sm-18 pr-5">
                                            <span >{{session.name}}</span>
                                        </h3>
                                        <div v-if="session.details" class="d-block hidden-xs mb-3 font-16 line-height-22">
                                            {{ stripHtml(session.details) }} 
                                            <span class="program-read-more-color">{{ theMaybeSetPLLCookieValue === 'de' ? 'Mehr lesen...' : 'Read more...' }}</span>
                                        </div>
                                    </a>
                                    <div v-if="session && session.experts" class="d-flex justify-content-between speakers-image align-items-center">
                                        <div class="d-flex athors flex-wrap gap-10">
                                            <div v-for="(expert, index) in session.experts" :key="index">
                                                <a v-if="expert && expert.slug" :href="'/speaker/'+expert.slug">
                                                    <div v-if="expert.avatarSquareSmall && expert.avatarSquareSmall.xxxx" class="text-color-1e font-18 font-md-14">
                                                        <img class="gdlr-speaker-thumbnail-inner resize mr-3 hidden-xs" :src="expert.avatarSquareSmall.xxxx" :alt="expert.forename + ' ' + expert.surname" width="150" height="150">
                                                        {{expert.forename}} {{expert.surname}}<span v-if="expert && expert.company">, &nbsp;<em> {{expert.company}}</em></span>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- end program card section  -->
                        </div>

                        <div>
                        </div>
                    </div>
                </div>
                <div class="m--t--5 hidden-md hidden-lg" v-if="showFilter && sessionstyle != 'small'">
                    <div v-if="widgetHtml" class="filter-on-right-side-blocks filter-on-right-side-third">
                        <div class="addtional-after-filter-html">
                            <div class="vhtml" v-html="widgetHtml">
                            </div>
                        </div>
                    </div>
                    <div class="shadow-s filters-outer-wrapper" v-if="programDisplayOnTrack && tracksFromQuery && tracksFromQuery.length">
                        <span class="h4" style="font-weight: bold;">{{ $t('moreTracks') }}</span>
                        <div v-if="tracksFromQuery && tracksFromQuery.length" class="m--t--15 tracks-side-display">
                            <div v-for="(aTrack, index) in tracksFromQuery" :value="aTrack._id" :key="index" class="more-tracks-list rounded-s" :class="{'sands-active-track': settingsPerm.trackID == aTrack._id}">
                                <a v-if="aTrack.slug" :href="'/'+aTrack.slug" class="track-item text-center rounded-s" >
                                    <span>{{ aTrack.name }}</span> 
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="noSessionsForFilter" class="p-x-s rounded-s shadow-s text-center">
                    <h3>{{ $t('noSessionsAfterFilter') }}</h3>
                </div>
            </div>
        </div>
        <div class="clear"></div>
        <div class="gdlr-item gdlr-content-item">
            <div id="stopper--sidebar" class="stopper--sidebar">&nbsp;</div>
        </div>
    </div>
    <!-- program display Ends  -->

 <!-- desktop filter starts -->
        <div class="hidden-xs hidden-sm col-md-3 session-item-filter sticky-track-Wrapper" v-if="showFilter && sessionstyle != 'small'">
            <div v-if="programDisplayOnTrack" class="shadow-s tracks-display-filter gdlr-first programDisplayOnTrack">
                <div class="h4" style="font-weight: bold;margin-top:15px;">{{ $t('moreTracks') }}</div>
                <div v-if="tracksFromQuery && tracksFromQuery.length" class="m--t--15 tracks-side-display">
                    <div v-for="(aTrack, index) in tracksFromQuery" :value="aTrack._id" :key="index">
                        <div :class="{'sands-active-track': settingsPerm.trackID == aTrack._id}" class="more-tracks-list rounded-s">
                            <a v-if="aTrack.slug" :href="'/'+aTrack.slug" class="track-item text-center rounded-s">
                                <span>{{ aTrack.name }}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <nav class="navbar" role="navigation" aria-label="program widgets">
                <div>
                        <div class="widget-track-divider">
                        </div>

                    <div class="tracks--filter-sticky" >
                        <div v-if="widgetHtml && !programDisplayOnTrack" class="filter-on-right-side-blocks filter-on-right-side-third">
                            <div class="addtional-after-filter-html">
                                <div class="vhtml" v-html="widgetHtml">
                                </div>
                            </div>
                        </div>
                        <div v-if="widgetHtml && programDisplayOnTrack" class="filter-on-right-side-blocks filter-on-right-side-third">
                            <div class="addtional-after-filter-html">
                                <div class="vhtml" v-html="widgetHtml">
                                </div>
                            </div>
                        </div>
                        
                    </div>

                </div>
            </nav>
        </div>
        <!-- display filters ends -->
</div>
    </div>
</template>

<script>
import moment from 'moment'
import { ApolloClient, InMemoryCache } from '@apollo/client/core'
import { provideApolloClient, useQuery } from "@vue/apollo-composable";
import CONCORD_QUERIES from "../services/concord_queries.js"
import { watch } from 'vue'
import Splide from '@splidejs/splide';

export default {
    name: "ProgramDisplay",
    props: {
        settingsPerm: Object
    },
    data() {
        return {
            seriesid: this.settingsPerm.seriesid,
            cookie: window.jQuery.cookie("event_location"),
            showNewLayout: this.settingsPerm.showNewLayout,
            showFilter: this.settingsPerm.displayfilters,
            showTimeAndDate: false,
            allLocations: this.settingsPerm.allLocations,
            showLanguageFlag: this.settingsPerm.showLanguageFlags,
            sessionQualification: "",
            trackFilters: "",
            typeFilters: "",
            titleAlign: this.settingsPerm.titletype,
            title: null,
            showRoomBasedOfInstance: false,
            titlesize: this.settingsPerm.titlesize,
            marginBottom: this.settingsPerm.marginbottom,
            days: null,
            pageSize: this.settingsPerm.pagesize,
            page: this.settingsPerm.page,
            sessionstyle: this.settingsPerm.sessionstyle,
            makefilterssticky: this.settingsPerm.makefilterssticky,
            wpSiteLanguage: this.settingsPerm.wpSiteLanguage,
            instanceid: "",
            result: null,
            testResults: null,
            loading: true,
            error: true,
            manipulateSessionTimeBy: 0,
            newLayoutBgColor: this.settingsPerm.newLayoutBgColor,
            tracksFromQuery: [],
            typesFromQuery: [],
            trackToFilter: 'ALL',
            typeToFilter: 'ALL',
            trackandTypeSlidersInitialized: false,
            weekDayGroup: [],
            widgetHtmlSet: false,
            widgetHtml: false,
            theMaybeSetPLLCookieValue: window.jQuery.cookie("pll_language"),
            languageToDisplay: null,
            browserLanguage: window.navigator.userLanguage || window.navigator.language,
            loadingfilter: true,
            noSessionsForFilter: false,
            programDisplayOnTrack: this.settingsPerm.programDisplayOnTrack,
            conferenceUniqueId: this.settingsPerm.conferenceUniqueId,
            dataToFilterDates: false,
            programDisplay: false,
            locationBasedColor:false,
            conferenceInstanceID: false,
            locationColor: false,
            isMobile: window.innerWidth <= 767, 
            activeTab: 'tracks',
            activePopoverTab: null,
            activePopoverTabmobile: null,
            splideTypesId: 'splide-types-' + Math.floor(Math.random() * 1000),
            splideTracksId: 'splide-tracks-' + Math.floor(Math.random() * 1000),
            types: 'types-' + Math.floor(Math.random() * 1000),
            tracks: 'tracks-' + Math.floor(Math.random() * 1000),
        };
    },
    created() {
        const cache = new InMemoryCache();
        const apolloClient = new ApolloClient({
            cache,
            uri: window.walkuere_app_data.concord_url,
        })
        if (this.theMaybeSetPLLCookieValue) {
            this.languageToDisplay = this.theMaybeSetPLLCookieValue;
        } else if (this.browserLanguage != this.wpSiteLanguage.slice(0, 2)) {
            this.languageToDisplay = this.browserLanguage;
        } else {
            this.languageToDisplay = this.wpSiteLanguage.slice(0, 2);
        }
        if (this.seriesid && this.allLocations && this.allLocations.length) {
            let doWeHaveAMatchingLocation = this.allLocations.find(aLocation => {
                return aLocation.select_series[0] == this.seriesid;
            })
            if (doWeHaveAMatchingLocation) {
                if (doWeHaveAMatchingLocation && doWeHaveAMatchingLocation.location_color) {
                    this.locationColor = doWeHaveAMatchingLocation.location_color;
                }
                if (doWeHaveAMatchingLocation && doWeHaveAMatchingLocation.manipulateSessionTime) {
                    this.manipulateSessionTimeBy = doWeHaveAMatchingLocation.manipulateSessionTime;
                    if (doWeHaveAMatchingLocation.location_color) {
                        this.locationBasedColor = doWeHaveAMatchingLocation.location_color;
                    }
                }
                this.showTimeAndDate = doWeHaveAMatchingLocation.location_session_time_is_active;
                if (doWeHaveAMatchingLocation.location_show_rooms_is_active) {
                    this.showRoomBasedOfInstance = doWeHaveAMatchingLocation.location_show_rooms_is_active;
                }
            }
        }
        if (this.settingsPerm && this.settingsPerm.sessionQualification && this.settingsPerm.sessionQualification.length) {
            this.sessionQualification = this.settingsPerm.sessionQualification.split(",");
        }
        if (this.settingsPerm && this.settingsPerm.trackfilters && this.settingsPerm.trackfilters.length) {
            this.trackFilters = this.settingsPerm.trackfilters.split(",");
        }
        if (this.settingsPerm && this.settingsPerm.typefilters && this.settingsPerm.typefilters.length) {
            this.typeFilters = this.settingsPerm.typefilters.split(",");
        }
        if (this.settingsPerm && this.settingsPerm.instanceid && this.settingsPerm.instanceid.length) {
            this.instanceid = this.settingsPerm.instanceid.split(",");
        }
        if (this.settingsPerm && this.settingsPerm.title && this.settingsPerm.title.length) {
            this.title = this.settingsPerm.title.replace(/_/g, ' ');
        }

        if (this.settingsPerm.instanceid) {
            this.conferenceInstanceID = this.settingsPerm.instanceid.split(",")
        }else if (this.settingsPerm.mlc_data && this.settingsPerm.mlc_data.length && this.settingsPerm.sands_edition_label_data) {
            this.getInstanceIdFromEditionLabel();
        }
        if (this.programDisplayOnTrack) {
            this.showNewLayout = 'disable';
            if (this.sessionstyle != 'small') {
                this.showFilter = 'enable'
            }
            let queryVariableForTrackPages = {
                id: this.settingsPerm.seriesid[0],
                trackIn: this.settingsPerm.trackID,
                page: 1,
                page_size: parseInt(this.pageSize),
                instanceId: false,
            }
            if (this.conferenceUniqueId && this.conferenceUniqueId.length) {
                queryVariableForTrackPages.instanceId = this.conferenceUniqueId;
            }
            let queryVariables = {
                id: queryVariableForTrackPages.id,
                trackIn: queryVariableForTrackPages.trackIn,
                page: queryVariableForTrackPages.page,
                pagesize: queryVariableForTrackPages.page_size,
                instanceId: queryVariableForTrackPages.instanceId
            };
            provideApolloClient(apolloClient)
            const {
                result
            } = useQuery(CONCORD_QUERIES.PROGRAM_FOR_TRACK_PAGE_QUERY(queryVariables), queryVariables);
            watch(result, value => {
                if (result && value && value.vueSessions) {
                    this.result = value;
                    this.programDisplay = this.getWeekDayAsGroup();
                    this.loading = false;
                }
            })
            if (this.settingsPerm && this.settingsPerm.showSessionTime && this.settingsPerm.programDisplayOnTrack) {
                this.showTimeAndDate = this.settingsPerm.showSessionTime;
            }
        } else {
            let variablesForQier = {
                id: this.seriesid,
                page_size: parseInt(this.pageSize),
                page: parseInt(this.page),
                typeIn: this.typeFilters,
                trackIn: this.trackFilters,
                qualificationIdIn: this.sessionQualification,
                instanceId: this.conferenceInstanceID,
            };

            provideApolloClient(apolloClient)
            const {
                result
            } = useQuery(CONCORD_QUERIES.SESSIONS_QUERY(variablesForQier), variablesForQier);
            watch(result, value => {
                if (result && value && value.vueSessions) {
                    this.result = value;
                    this.programDisplay = this.getWeekDayAsGroup()
                    // console.log('xxxxxxx',this.programDisplay)
                    this.loading = false;
                } else {
                    this.loading = false;
                }
            })
        }

        this.displaywidget();
    },
    mounted() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('resize', this.makeTracksFilterStickyonResize);
        this.checkIfMobile();
        window.addEventListener('resize', this.checkIfMobile);
        window.addEventListener('resize', this.initializeSliders);
    },
    beforeUpdate() {
        if (this.result && this.result.vueSessions && this.result.vueSessions.Sessions && this.result.vueSessions.Sessions.length && this.showFilter && this.showFilter == 'enable' && this.sessionstyle != 'small') {
            let sessions = this.result.vueSessions.Sessions;
            sessions.forEach(aSession => {
                if (aSession && aSession.sessionType && aSession.sessionType.type) {
                    let doWeFindAMatch = this.typesFromQuery.find(atyp => {
                        return atyp.uniqueId == aSession.sessionType.uniqueId
                    })
                    if (!doWeFindAMatch) {
                        this.typesFromQuery.push(aSession.sessionType);

                    }

                }
                if (aSession && aSession.tracks && aSession.tracks.length) {
                    aSession.tracks.forEach(aTrack => {
                        if (aTrack && aTrack.name && !this.tracksFromQuery.includes(aTrack)) {
                            this.tracksFromQuery.push(aTrack);
                        }
                    });
                }
                this.loadingfilter = false;
            });
        }
    },
    updated() {
        setTimeout(() => {
            this.loadJsNew()
            if (!this.trackandTypeSlidersInitialized) {
                this.initializeSliders();
            }
            this.cookie = window.jQuery.cookie("event_location");
            if (this.cookie && (typeof this.cookie !== "undefined") && (this.cookie != "") && (this.cookie != "all")) {
                window.jQuery('.mlc-location-dependent-block-visible').addClass('mlc-location-dependent-block-invisible');
                window.jQuery('.mlc-location-dependent-block-visible').removeClass('mlc-location-dependent-block-visible');
                window.jQuery('.mlc-location-dependent-block-invisible.' + this.cookie).addClass('mlc-location-dependent-block-visible');
                window.jQuery('.mlc-location-dependent-block-invisible.' + this.cookie).removeClass('mlc-location-dependent-block-invisible');
            } else {
                // we do NOT have a location so we do somtehing with location dependend things
                window.jQuery('.mlc-location-independent-block-invisible').addClass('mlc-location-independent-block-visible');
                window.jQuery('.mlc-location-independent-block-invisible').removeClass('mlc-location-independent-block-invisible');
            }
            if (this.theMaybeSetPLLCookieValue && (typeof this.theMaybeSetPLLCookieValue !== "undefined") && (this.theMaybeSetPLLCookieValue != "") && (this.theMaybeSetPLLCookieValue == 'de')) {
                window.jQuery('.language-dependent-block-invisible-de').addClass('language-dependent-block-visible');
                window.jQuery('.language-dependent-block-invisible-de').removeClass('language-dependent-block-invisible-de');
            } else {
                window.jQuery('.language-dependent-block-invisible').addClass('language-dependent-block-visible');
                window.jQuery('.language-dependent-block-invisible').removeClass('language-dependent-block-invisible');
            }
        }, 300);

        if (!this.loadingfilter && window && window["makeFiltersSticky"]) {
            window["makeFiltersSticky"]();
        }
        setTimeout(() => {
            this.hideMenu();
            this.setCookies();
        }, 1200);
    },
    computed: {
        hasActiveFilters() {
            return this.typeToFilter !== 'ALL' || this.trackToFilter !== 'ALL';
        }
    },
    methods: {
        getInstanceIdFromEditionLabel(){
            if(this.settingsPerm.mlc_data && this.settingsPerm.mlc_data.length && this.settingsPerm.sands_edition_label_data) {

                let mlcDataForThisSeries = this.settingsPerm.mlc_data.find(aMlcData => {
                    return aMlcData.select_series[0] == this.settingsPerm.seriesid;
                });
                if (mlcDataForThisSeries && mlcDataForThisSeries.editionlabel && mlcDataForThisSeries.editionlabel.length) {
                    let editionLabel =  mlcDataForThisSeries.editionlabel.toLowerCase();
                    if (this.settingsPerm.sands_edition_label_data[editionLabel].edition_identifier) {
                        this.conferenceInstanceID = this.settingsPerm.sands_edition_label_data[editionLabel].edition_identifier;
                    }
                    
                }
            }
        },
        selectTrack(track) {
            this.selectedTrack = track;
            this.pgetWeekDayAsGroup();
        },
        pgetWeekDayAsGroup() {
            this.programDisplay = this.getWeekDayAsGroup();
            this.getAllSessionTimes();
        },
        getWeekDayAsGroup() {
            let weeKDaysAsDate = [];
            if (this.result && this.result.vueSessions && this.result.vueSessions.Sessions && this.result.vueSessions.Sessions.length) {
                if (this.typeToFilter || this.trackToFilter) {
                    let filteredSessions = [];
                    this.result.vueSessions.Sessions.forEach(aSession => {
                        let typeFilterMatches = true;
                        let trackFilterMatches = true;
                        if (this.typeToFilter && this.typeToFilter.length && this.typeToFilter != "ALL") {
                            typeFilterMatches = false;
                            if (aSession && aSession.sessionType && aSession.sessionType._id && aSession.sessionType._id === this.typeToFilter) {
                                typeFilterMatches = true;
                            }
                        }
                        if (this.trackToFilter && this.trackToFilter.length && this.trackToFilter != "ALL") {
                            trackFilterMatches = false;
                            if (aSession && aSession.trackIds && aSession.trackIds.length && aSession.trackIds.includes(this.trackToFilter)) {
                                trackFilterMatches = true;
                            }
                        }
                        if (typeFilterMatches && trackFilterMatches) {
                            filteredSessions.push(aSession);
                        }
                    });
                    if (filteredSessions && filteredSessions.length) {
                        filteredSessions.forEach(session => {
                            if (session && session.type && session.type == 'Break') {
                                return;
                            }
                           let startdate = this.getStartDateAfterCalculatingProperHours(session.localizedStartDate) 
                        // moment(session.localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('DD-MM-YYYY');
                            weeKDaysAsDate.push({
                                startdate,
                                session
                            });
                        });

                    }
                } else {
                    this.result.vueSessions.Sessions.forEach(session => {
                        let startdate = this.getStartDateAfterCalculatingProperHours(session.localizedStartDate) 
                        // moment(session.localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('DD-MM-YYYY');
                        weeKDaysAsDate.push({
                            startdate,
                            session
                        });
                    });
                }
            }
            const groupByTimes = (weeKDaysAsDate) => Object.values(weeKDaysAsDate.reduce((weeKDaysAsDate, {
                startdate,
                session
            }) => {

                if (weeKDaysAsDate[startdate]) {
                    weeKDaysAsDate[startdate].sessions.push(session);
                } else {
                    weeKDaysAsDate[startdate] = {
                        startdate,
                        sessions: [session]
                    };
                }
                return weeKDaysAsDate;
            }, {}));
            let weekDayGroup = groupByTimes(weeKDaysAsDate)
            if (weekDayGroup && weekDayGroup.length == 0) {
                this.noSessionsForFilter = true;
            } else {
                this.noSessionsForFilter = false;
            }
            this.dataToFilterDates = weekDayGroup;
            return weekDayGroup;
        },
        getStartDateAfterCalculatingProperHours(sessionStartDate){
            if (sessionStartDate && this.manipulateSessionTimeBy) {
                if (Math.sign(this.manipulateSessionTimeBy) === 1) {
                    return moment(sessionStartDate, 'DD/MM/YYYY HH:mm:ss').add(Math.abs(this.manipulateSessionTimeBy), 'hours').format('DD-MM-YYYY');
                } else if (Math.sign(this.manipulateSessionTimeBy) === -1) {
                    return moment(sessionStartDate, 'DD/MM/YYYY HH:mm:ss').subtract(Math.abs(this.manipulateSessionTimeBy), 'hours').format('DD-MM-YYYY');
                }
            }
            return moment(sessionStartDate, 'DD/MM/YYYY HH:mm:ss').format('DD-MM-YYYY');
        },
        getTime(localizedDate) {
            if (this.manipulateSessionTimeBy) {
                if (Math.sign(this.manipulateSessionTimeBy) === 1) {
                    return moment(localizedDate, 'DD/MM/YYYY HH:mm:ss').add(Math.abs(this.manipulateSessionTimeBy), 'hours').format('HH:mm');
                } else if (Math.sign(this.manipulateSessionTimeBy) === -1) {
                    return moment(localizedDate, 'DD/MM/YYYY HH:mm:ss').subtract(Math.abs(this.manipulateSessionTimeBy), 'hours').format('HH:mm');
                }
            } else {
                return moment(localizedDate, 'DD/MM/YYYY HH:mm:ss').format('HH:mm');
            }

        },
        getDay(startDate) {
            moment.locale(this.languageToDisplay);
            return moment(startDate, 'DD. MMM YYYY').format('dddd');
        },
        getFormattedDate(date) {

            moment.locale(this.languageToDisplay);
                if (this.isMobile) {
                    return moment(date, 'DD. MMM YYYY').format('D MMM');
                } else {
                    // return date;
                    return moment(date, 'DD. MMM YYYY').format('D MMMM YYYY');
                }
        },
        getFormattedDaily(date) {

            moment.locale(this.languageToDisplay);
                if (this.isMobile) {
                    return moment(date, 'DD. MMM YYYY').format('ddd');
                } else {
                    // return date;
                    return moment(date, 'DD. MMM YYYY').format('dddd');
                }
        },
        getFormattedDateDaily(date) {
            moment.locale(this.languageToDisplay);
            return moment(date, 'DD. MMM YYYY').format('D MMMM YYYY');
        },
        handleResize() {
        this.isMobile = window.innerWidth <= 767;
        },
        getAllSessionTimes() {
            let weekDaysDate = [];
            if (this.dataToFilterDates && this.dataToFilterDates.length) {
                this.dataToFilterDates.forEach(aDay => {
                    if (aDay && aDay.startdate) {
                        let startdate = moment(aDay.startdate, 'DD-MM-YYYY').format('DD. MMM YYYY');
                        if (!weekDaysDate.includes(startdate)) {
                            weekDaysDate.push(startdate);
                        }
                    }
                });
            }
            this.days = weekDaysDate.length;
            return weekDaysDate;
        },
        getaDayTimeIndex(index) {
            return 'aSingleDayHeaderLink' + index;
        },
        async getWidget() {

            let jQueryVue = window.jQuery;
            const resultt = await jQueryVue.ajax({
                url: window.sands_ajax_object.ajaxurl,
                type: 'get',
                data: {
                    'action': 'get_widgetarea_content',
                    'href': window.location.href,
                    'title': document.title,
                },
                success: function (response) {
                    return response
                }
            });
            return resultt;

        },
        displaywidget() {
            let thiz = this;
            if (!this.widgetHtml) {
                this.getWidget().then((data) => {
                    thiz.widgetHtml = data;
                    thiz.makeTracksFilterSticky();
                })
            }
        },
        loadJsNew() {
            setTimeout(() => {
                if (!this.cookie || this.cookie == 'all' || this.cookie == undefined) {
                // Hide the Small display if they are empty
                /* eslint-disable */
                var smallDisplayBlock = $('.small-display-program');
                if (smallDisplayBlock.length > 0) {
                    window.jQuery(smallDisplayBlock).each(function (singleSmallview) {
                        //console.log($(this));
                        var identifier = window.jQuery(this).data('smallblockid');
                        if (identifier) {
                            var rowSelector = '.small-display-program.' + identifier;
                            if (window.jQuery(rowSelector).find(".gdlr-session-item-content-wrapper").length) {
                                window.jQuery('.small-display-program.' + identifier).show()
                            } else {
                                window.jQuery('.small-display-program.' + identifier).hide();
                            }
                        }
                    });
                }
                /* eslint-enable */
            }
            }, 500);
  
           
        },
        setCookies() {
            if (this.theMaybeSetPLLCookieValue && (typeof this.theMaybeSetPLLCookieValue !== "undefined") && (this.theMaybeSetPLLCookieValue != "") && (this.theMaybeSetPLLCookieValue == 'de')) {
                window.jQuery('.language-dependent-block-invisible-de').addClass('language-dependent-block-visible');
                window.jQuery('.language-dependent-block-invisible-de').removeClass('language-dependent-block-invisible-de');
            } else {
                window.jQuery('.language-dependent-block-invisible').addClass('language-dependent-block-visible');
                window.jQuery('.language-dependent-block-invisible').removeClass('language-dependent-block-invisible');
            }
        },

        makeTracksFilterSticky() {
            setTimeout(() => {
                let trackFilter = window.jQuery('.tracks--filter-sticky:visible');
                let trackWrapper = window.jQuery('.sticky-track-Wrapper:visible');
                let stopperForTrackFilter = window.jQuery('.widget-track-divider:visible');
                let doWeHaveAStopperDiv = false;
                let doWeHaveAStopperDivTop = 0;
                if (window.jQuery('.stopper--sidebar:visible').length > 0) {
                    doWeHaveAStopperDiv = window.jQuery('.stopper--sidebar:visible');
                    if (window.jQuery(window).scrollTop() && window.jQuery(window).scrollTop() > 150) {
                        doWeHaveAStopperDivTop = window.jQuery(window).scrollTop() + doWeHaveAStopperDiv[0].getBoundingClientRect().top;
                    }else{
                        doWeHaveAStopperDivTop = doWeHaveAStopperDiv[0].getBoundingClientRect().top;
                    }
                }
                if (trackFilter && trackWrapper && stopperForTrackFilter && trackFilter.length && trackWrapper.length && stopperForTrackFilter.length) {
                    let parentWrapperWidth = trackWrapper.width();
                    window.onscroll = function () {
                        let windowTop = window.jQuery(window).scrollTop(); 
                        let trackFilterBounding = trackFilter[0].getBoundingClientRect();
                            parentWrapperWidth = trackWrapper.width();
                            if(windowTop + 600 >= doWeHaveAStopperDivTop){
                                console.log('we stop the filter');
                                trackFilter.css('top', '10px');
                                trackFilter.css('position', 'relative');
                                trackFilter.css('width', parentWrapperWidth + 'px');
                            }else{
                                if ((trackFilterBounding && trackFilterBounding.top && trackFilterBounding.top < 150 && stopperForTrackFilter[0].getBoundingClientRect().top < 150) && (window.jQuery('.footer-wrapper')[0].getBoundingClientRect().top - trackFilterBounding.bottom >= 25)) {
                                    trackFilter.css('top', '150px');
                                    trackFilter.css('position', 'fixed');
                                    trackFilter.css('width', parentWrapperWidth + 'px');
                                } else if (stopperForTrackFilter[0].getBoundingClientRect().top > 150) {
                                    trackFilter.css('top', '10px');
                                    trackFilter.css('position', 'relative');
                                    trackFilter.css('width', parentWrapperWidth + 'px');
                                }
                            }

                    }
                    window.onresize = function () {
                        let parentWrapperWidth = trackWrapper.width();
                        trackFilter.css('width', parentWrapperWidth + 'px');
                    }
                }
            }, 2000);
        },
        stripHtml(input) {
            // Create a temporary element to convert the HTML to plain text
            const doc = new DOMParser().parseFromString(input, 'text/html');
            
            // Extract the plain text content
            const textContent = doc.body.textContent || doc.body.innerText || '';
            
            // Return only the first 150 characters
            return textContent.length > 250 ? textContent.substring(0, 250): textContent;
        },
        
        makeTracksFilterStickyonResize() {
            let width = window.jQuery('.gdlr-session-item-content-wrapper:visible').outerWidth();
        
            window.jQuery('.thisisthefirstdivider').css('width', width + 'px');
        },

        setFilter(value, type) {
            this.activeTab = type === 'type' ? 'types' : 'tracks';
            if (type === 'type') {
                this.typeToFilter = value;
            } else if (type === 'track') {
                this.trackToFilter = value;
            }
            this.pgetWeekDayAsGroup();
            this.closePopover();
        },

        resetFilters() {
            this.typeToFilter = 'ALL';
            this.trackToFilter = 'ALL';
            this.pgetWeekDayAsGroup();
            this.activePopoverTabmobile = null;
        },

        isActiveTab(tab) {
            return this.activeTab === tab;
        },

        checkIfMobile() {
            this.isMobilee = window.innerWidth <= 425;
        },

        openPopover(tab) {
            this.activePopoverTab = tab;
            this.activePopoverTabmobile = tab;
        },
        closePopover() {
            this.activePopoverTab = null;
        },

        setActiveTab(tab) {
            this.activeTab = tab;
        },

        initializeSliders() {
            setTimeout(() => {
                // Initialize Splide for types tab
                new Splide(`#${this.splideTypesId}`, {
                type: 'slide',
                perPage: 4,
                gap: '0.6rem', // Adjust space between slides
                arrows: true, // Enable arrows
                pagination: false, // Disable pagination
                }).mount();

                // Initialize Splide for tracks tab
                new Splide(`#${this.splideTracksId}`, {
                type: 'slide',
                autoWidth: true,
                gap: '0.6rem', // Adjust space between slides
                arrows: true, // Enable arrows
                pagination: false, // Disable pagination
                perMove: 4,
                rewind: false,
                start: 0,
                updateOnMove: true,
                }).mount();
            }, 100);
        },
        hideMenu() {
            if (!document.querySelector('#timetable-overview-custom')) return;

            let lastScrollTop = 0;
            const menu = document.querySelector('.gdlr-header-wrapper');
            const marketingBanner = document.querySelector('.main-top-header-banner');
            const widget = document.querySelector('.tracks-display-filter');

            const scrollTrigger = widget ? 2200 : 300;
            const scrollDeltaThreshold = 50; // only trigger if scroll is more than 25px

            window.addEventListener('scroll', function () {
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const delta = Math.abs(scrollTop - lastScrollTop);

                if (delta < scrollDeltaThreshold) {
                    return; // ignore small scrolls
                }

                if (scrollTop < scrollTrigger) {
                    if (menu) menu.classList.remove('hideprogram');
                    if (marketingBanner) marketingBanner.classList.remove('hide');
                } else {
                    if (scrollTop > lastScrollTop) {
                        // Scrolling down
                        if (menu) menu.classList.add('hideprogram');
                        if (marketingBanner) marketingBanner.classList.add('hide');
                    } else {
                        // Scrolling up

                        // Logic: show marketingBanner only if we are in a certain scroll range
                        if (scrollTop < 2200 && widget) {
                            if (marketingBanner) marketingBanner.classList.remove('hide');
                        }

                        if (scrollTop < 400) {
                            if (marketingBanner) marketingBanner.classList.remove('hide');
                        }

                        if (menu) menu.classList.remove('hideprogram');
                    }
                }
                lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
            });
        }
    },

};
</script>

<style lang="css" scoped>


.main-program-vue .onTop .aDayLink .gdlr-session-item-head-info.sands-not-active, .main-program-vue .onTop .aDayLink .gdlr-session-item-head-info.sands-active{
     /* border-bottom: 12px solid #58676f !important; */
     background-color: #F0F0F0;
     border-radius: 12px;
}
.main-program-vue .onTop .activeDayLink.aDayLink .gdlr-session-item-head-info{
     /* border-color: var(--my-color) !important; */
     background-color: var(--my-color) !important;
}
.main-program-vue .activeDayLink .gdlr-session-item-head-info div{
     color: #FFFFFF!important;

}
.new-layout-container {
    padding: 15px 16px 42px 49px!important;
    height: 550px;
    border-radius: 15px;
}

.new-layout-container .speakers-image {
    padding: 0px;
}

.new-layout-container .row {
    margin: 0px !important;
}

.new-layout-container h3 {
    text-transform: none;
}

.eachSessionOfNewLayout {
    margin-bottom: 15px;
}

.gdlr-speaker-thumbnail-inner.resize {
    width: 40px;
    height: 40px;
    border-radius: 200px;
    object-fit: cover;
}
.programm-small-author {
    width: 70px;
    border-radius: 200px;
    object-fit: cover;
}

.gdlr-session-item .gdlr-speaker-thumbnail {
    max-width: 70px;
}

.eachSessionOfNewLayout .speakers-image {
    display: flex;
    justify-content: space-around;
}

.gdlr-session-item-title.m--t--0 {
    font-weight: 700;
}

.new-layout-container .gdlr-speaker-thumbnail {
    margin-bottom: 5px;
}

.gdlr-speaker-thumbnail-inner.resize img {
    height: 60px;
    object-fit: cover;
}

.new-layout-container a {
    color: #000;
}

.eachSessionOfNewLayout .session-type-name {
    margin: 0px;
    font-weight: 700;
    font-size: 25px;
}

.eachSessionOfNewLayout .speakers-name-and-company {
    font-size: 20px;
    font-weight: 400;
}

.new-layout-container .sands-image-colored-overlay-hover img {
    border-radius: 50%;
    height: 60px;
    width: 60px;
    object-fit: cover;
}

.session-display-small-new-layout {
    height: 490px;
    overflow-y: scroll;
    overflow-x: hidden;
    word-break: break-word;
}

.session-display-small-new-layout::-webkit-scrollbar {
    width: 12px;
}

.session-display-small-new-layout::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
}

.session-display-small-new-layout::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
}

.filterSelectVue {
    width: 100%;
    font-weight: 600;
    border: none !important;
    /* font-size: 16px; */
}

.new-layout-session-type {
    padding: 7px 8px 5px 8px;
    background-color: rgba(255, 255, 255);
}

.new-layout-session-type h4 {
    margin: 0px;
    font-weight: 600;
}

.program-filter-select {
    padding: 5px;
}

.p--l--3 {
    padding-left: 12px;
}

.p--l--0{
    padding-left: 0px;
}

.m--t--0 {
    margin-top: 0px;
}

.session-display-small-new-layout .session-type-icons {
    margin: 30px 0px 45px;
}

.session-type-badge-styling {
    padding: 0px 3px;
}

.program-tabs{
       cursor: pointer;
}

@media (max-width: 449px) {
    .new-layout-container .sands-image-colored-overlay-hover img {
        height: 20vw!important;
        width: 20vw!important;
    }
}

    /* @media (min-width: 768px) {
        #timetable-overview-custom .sands-active {
            background-color: transparent !important;
        }
    } */

@media (max-width: 767px) {
        /* #timetable-overview-custom .sands-active {
            background-color: transparent !important;
        } */

    .new-layout-container .sands-image-colored-overlay-hover img {
        height: 10vw;
        width: 10vw;
        border-radius: 50%;

    }

    .new-layout-container h3 {
        font-size: 20px;
        text-transform: none;
    }

    .eachSessionOfNewLayout .speakers-name-and-company {
        font-size: 16px;
    }
    .filters-inner-wrapper{
        display: flex;
        flex-direction: column !important;
    }

    .filters-col{
        padding-bottom: 10px;
    }

    .new-layout-container {
        padding: 15px 16px 42px 16px!important;
    }

    .wrapper-padding-mobile{
        padding-left: 0px;
        padding-right: 0px;
    }

    .img-black-white {
        margin-left: 15px;
        margin-bottom: 10px;
    }
    .program-header-pils {
        padding: 0.5rem;
        border-radius: 4px;
    }
    .program-tabs{
        padding: 4px 7px!important;
    }
    .athors{
        flex-direction: column;
        gap: 5px;
    }

    .main-program-vue .onTop .aDayLink .gdlr-session-item-head-info.sands-not-active, .main-program-vue .onTop .aDayLink .gdlr-session-item-head-info.sands-active{
     border-radius: 8px;
    }
}

@media (max-width: 426px) {
    .program-tabs{
        padding: 4px 2px!important;
    }
}
@media (max-width: 991px) {
    .eachSessionOfNewLayout .speakers-image {
        padding-left: 22px;
    }
}
@media (max-width: 1200px) {
    .speaker-images-mobile-view{
        display: inline-flex;
        flex-wrap: wrap;
    }
}


.session-type-name-color {
    /* color: #fff; */
    margin: 0;
    font-weight: 600;
}

select {
    background-color: #f0f0f0;
}

.filter-on-right-side-blocks {
    width: 100% !important;
}

.sands-container .vueApp2 .session-item-filter .container-fluid {
    margin: 0px 30px;
}

.filters-outer-wrapper{
    border-radius: 25px;
    margin-bottom: 20px;
    padding: 4px 0px 20px 20px;
}

.filters-inner-wrapper{
    display: flex;
    flex-direction: row;
}
.m--t--5{
    margin-top: 5px;
}
.m--t--15{
    margin-top: 15px;
}
.track-item {
    font-weight: bold;
    color: #353638;
}
.sands-active-track{
    background-color: v-bind(locationBasedColor) !important;
}
.sands-active-track .track-item {
    color: #fff;
}
.tracks-side-display{
    display: flex;
    flex-wrap: wrap;
}
a:hover.track-item{
    text-decoration: none;
}
.rounded-corners-10{
    border-radius: 10px;
}
.more-tracks-list{
    background-color: #ECECEC;
    margin-bottom:9px;
    margin-right: 2px;
    padding: 5px;
}

.tracks-display-filter{
    padding: 7px 13px;
    border-radius: 25px;
}

.img-black-white {
    filter: grayscale(100%);
}

/* .gdlr-session-break-title, .session-break-info {
    font-size: 16px;
} */
.program-header-color {
    background-color: var(--my-color) !important;
}
.program-header-pils {
    background-color: #FFFFFF;
    padding: 0.5rem;
    border-radius: 8px;
    font-weight: 600;
}
.program-header-pils-language {
    background-color: #F0F0F0!important;
}
@media (max-width: 767px) {
    .program-header-pils {
        padding: 0.5rem;
        border-radius: 4px;
    }
}
.program-read-more-color{
    font-weight: 600;
}
.line-divider {
    border: 0;
    height: 4px;
    background-color: #0A1433;
    margin-top: 0;
    margin-bottom:10px;
}

.program-filter-select option {
    color: #e42b2b;
    border: 2px solid black;
    border-radius: 40px;
}

.options-container {
    /* display: flex;
    flex-wrap: wrap; */
    /* gap: 10px; */
    background: #F0F0F0;
    padding: 16px 24px;
}
.option-item {
    cursor: pointer;
    padding: 12px 16px;
    background: #FFFFFF;
    border: 1px solid #0A1433;
    border-radius: 80px;
    transition: background-color 0.3s;
}
.option-item:hover {
    background: #0A1433;
    color: #FFFFFF;
}

.nav-tabs>li>a{
    color: #0A1433;
    text-decoration: none !important;
}
#timetable-overview-custom .nav-tabs>li.active>a{
    background: #0A1433!important;
    color: #FFFFFF!important;
}
.tab-content {
    border-top: 3px solid #0A1433;;
}
.splide__arrow {
  background: #333;
  border: none;
  color: white;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s, transform 0.3s;
}

.splide__arrow:hover {
  background: #555;
  transform: scale(1.1);
}


.splide__arrow svg {
  fill: currentColor;
  width: 1rem;
  height: 1rem;
}
.popover-full-screen {
  position: fixed;
  top: 15px;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.popover-header {
  position: absolute;
  top: 50px;
  right: 40px;
}

.close-popover {
  /* background: #F0F0F0F0;
  border-radius: 100%;
  border: none;
  font-size: 13px;
  color: #1E2847CC;
  padding: 13px; */
  width:48px;
height: 48px;
border-radius: 60px;
border: none;

}

.popover-content {
  width: 100%;
  height: 100%;
  /* max-width: 600px; */
  background: white;
  padding: 20px;
  margin-top: 50px;
}

.option-item {
  padding: 10px;
  cursor: pointer;
}
.program_item-popover-filter{
    padding: 12px 16px;
    color: #0A1433;

}
.program_item-popover-filter:hover{
    font-weight: 800;
}
.session-name{
    text-transform: lowercase;
}
.session-name::first-letter{
    text-transform: capitalize; 
}

@media (max-width: 390px) {
    .program-header-pils {
        font-size: 8px;
    }
    .session-type-name {
        font-size: 8px;
    }
}

.option-item.selected {
    background-color: #0A1433; 
    color: #fff;
}
.popover-menu-program.selected {
    font-weight: 800;
}
.bg__active{
    background-color: #0A1433!important;
}
.bg__active>a{
    color: #fff!important;
    border: none;
    background-color: #0a1433 !important;
}

.onTop{
    visibility: hidden;
}

.onTop0 {
    visibility: visible;
}

.onTop1, .onTop2, .onTop3, .onTop4, .onTop5, .onTop6{
    height: 0px!important;
    margin: 0px!important;
    padding: 0px!important;
}

.day-selector-wrapper{
   border-top: 10px solid #0A1433;
}

.central_data .gdlr-page-caption{
 font-size: 18px;
 line-height: 25px;
 font-weight: 600;
}

</style>
